import { RecentPurchase } from "../../../api/payments/overview/overview.responses";
import { Badge } from "../../ui/Badge";
import { Card, CardContent, CardHeader, CardTitle } from "../../ui/Card";
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableHeader,
  TableRow,
} from "../../ui/Table";

const SOURCE_LABELS: Record<string, string> = {
  IOS: "iOS",
  ANDROID: "Android",
  WEB: "Web",
  PROMOTIONAL: "Promotional",
  UNKNOWN: "Unknown",
};

interface RecentPurchasesCardProps {
  recentPurchases: RecentPurchase[];
}

export function RecentPurchasesCard({ recentPurchases }: RecentPurchasesCardProps) {
  return (
    <Card>
      <CardHeader>
        <CardTitle className="text-base">Recent Purchases</CardTitle>
      </CardHeader>
      <CardContent className="p-0">
        {recentPurchases.length === 0 ? (
          <p className="px-6 pb-4 text-sm text-muted-foreground">
            No purchases yet.
          </p>
        ) : (
          <Table>
            <TableHeader>
              <TableRow>
                <TableHead>Route</TableHead>
                <TableHead>User ID</TableHead>
                <TableHead>Platform</TableHead>
                <TableHead>Status</TableHead>
                <TableHead>Date</TableHead>
              </TableRow>
            </TableHeader>
            <TableBody>
              {recentPurchases.map((p) => (
                <TableRow key={p.id}>
                  <TableCell className="max-w-[180px] truncate font-medium">
                    {p.routeName ?? p.routeId}
                  </TableCell>
                  <TableCell className="max-w-[140px] truncate font-mono text-xs text-muted-foreground">
                    {p.appUserId}
                  </TableCell>
                  <TableCell>
                    {SOURCE_LABELS[p.source] ?? p.source}
                  </TableCell>
                  <TableCell>
                    <Badge variant={p.isActive ? "default" : "secondary"}>
                      {p.isActive ? "Active" : "Revoked"}
                    </Badge>
                  </TableCell>
                  <TableCell className="text-muted-foreground">
                    {new Date(p.grantedAt).toLocaleDateString()}
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        )}
      </CardContent>
    </Card>
  );
}
